import Vue from "vue";
import {
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Header,
  Footer,
  Container,
  Main,
  Row,
  Col,
  Button,
  Carousel,
  CarouselItem,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Backtop,
  Icon,
  Link
} from "element-ui";
import '../theme/element-variables.scss'

Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Header);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Container);
Vue.use(Row);
Vue.use(Col);
Vue.use(Button);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Backtop);
Vue.use(Icon);
Vue.use(Link);

